import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { injectIntl, intlShape } from 'react-intl';

import { useFlagData } from './utils';

export const FlagMessageContext = createContext({
  showModal: false,
  setShowModal: noop,
  flagMessage: noop,
  setSelectedReason: noop,
  setSelectedCategory: noop,
  setUserComment: noop,
  selectedReason: null,
  selectedCategory: null,
  userComment: null,
  setCurrentStep: noop,
  goBack: noop,
  currentStep: null,
  flagData: null
});

const FlagMessageContextProvider = ({ children, intl, ...rest }) => {
  const flagData = useFlagData(intl);
  return (
    <FlagMessageContext.Provider value={{ ...rest, flagData }}>
      {children}
    </FlagMessageContext.Provider>
  );
};

FlagMessageContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  flagMessage: PropTypes.func,
  setSelectedReason: PropTypes.func,
  setSelectedCategory: PropTypes.func,
  setUserComment: PropTypes.func,
  selectedReason: PropTypes.object,
  selectedCategory: PropTypes.object,
  userComment: PropTypes.string,
  setCurrentStep: PropTypes.func,
  currentStep: PropTypes.string,
  goBack: PropTypes.func,
  intl: intlShape
};

exports.FlagMessageContextProvider = injectIntl(FlagMessageContextProvider);
